import { QuickEventDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { Lock, Trash2, UserCog } from 'lucide-react';

interface QuickEventActionHandlers {
  onViewRecord?: (event: QuickEventDTO) => void;
  onDelete: (event: QuickEventDTO) => void;
}

const createQuickEventActions =
  (handlers: QuickEventActionHandlers) =>
  (row: QuickEventDTO): TableAction[] => {
    const actions: TableAction[] = [];

    if (handlers.onViewRecord) {
      actions.push({
        label: 'View Record',
        onClick: () => handlers.onViewRecord!(row),
        icon: <UserCog className="w-4 h-4" />,
      });
    }

    actions.push({
      label: 'Delete Record',
      onClick: () => handlers.onDelete(row),
      icon: <Trash2 className="w-4 h-4" />,
      confirmMessage: 'Are you sure you want to delete this record?',
      className: 'text-red-600 hover:text-red-700',
    });

    return actions;
  };

export default createQuickEventActions;
